import {css} from 'lit';
export const styles = css`ef-dot-menu::part(icon-block subscribe dot-item-active) {
    --icon-color-primary: var(--warning);
  }
  ef-dot-menu::part(icon-block favorite dot-item-active) {
    --icon-color-primary: #ff8b62;
  }
`;
export default styles;
